// extracted by mini-css-extract-plugin
module.exports = {"dispos":"CallNotes_dispos__RZn0k","callNotes":"CallNotes_callNotes__BHa5v","container":"CallNotes_container__wZ_o_"};